import Vue from 'vue'
import  axios from 'axios'
import {Message, Loading} from "element-ui"
import router from "./route/index";
import qs from 'qs'

let loading;        //定义loading变量

axios.defaults.timeout = 120000;
Vue.use(Loading);
const http = axios.create({
    timeout: 120000,
    responseType: 'json',
    withCredentials: true,
    'validateStatus': (status) => status >= 200 && status <= 500,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
});

function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.1)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}

// 请求拦截  设置统一header
http.interceptors.request.use(config => {
    // 加载
    startLoading();

    if (!window.sessionStorage.getItem('wh-access-token') ||
            (config.params && config.params.grant_type && config.params.grant_type !== '' && config.params.refresh_token &&
                config.params.refresh_token !== '')) {
        // c3VwcGxpdGVyOjEyMzc4OQ==
        // c3VwcGxpdGVyOjEyMzQ1Ng==
        config.headers['Authorization'] = 'Basic c3VwcGxpdGVyOjEyMzQ1Ng==';
    } else {
        let token = window.sessionStorage.getItem('wh-access-token');
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
}, (error) => Promise.reject(error));

// 响应拦截  401 token过期处理
http.interceptors.response.use(res => {
    endLoading();
    const status = Number(res.status) || 200;
    const code = Number(res.data.code) || 200;
    if (status === 401) {
        window.sessionStorage.clear();
        router.push('/login');
        return;
    } else if (status === 403) {
        Message({
            message: '用户无权访问后台，请调整端点权限',
            type: 'error',
            duration: 3 * 1000
        });
    } else if (status !== 200) {
        if (!res.data.message) {
            if (res.data.error) {
                if (res.data.error_description === 'Bad credentials') {
                    Message({
                        'message': '用户名密码错误，请确认后再登陆',
                        'type': 'error',
                        'duration': 3 * 1000
                    });
                } else {
                    Message({
                        'message': '授权出错，请确认权限信息',
                        'type': 'error',
                        'duration': 3 * 1000
                    });
                }
            } else {
                Message({
                    'message': res.data.message || '服务器错误',
                    'type': 'error',
                    'duration': 3 * 1000
                });
            }
        } else {
            Message({
                'message': res.data.message || '服务器错误',
                'type': 'error',
                'duration': 3 * 1000
            });
        }
        return Promise.reject(res);
    }
    if (code !== 200 && code === 202) {
        Message({
            'message': res.data.message || '服务器错误',
            'type': 'error',
            'duration': 3 * 1000
        });
        return;
    }
    return res;
}, error => {
    // 错误提醒
    endLoading();
    return Promise.reject(new Error(error));
});


export default {
    get: function (url, params) {
        return http.get(url, {params: params});
    },
    post: function (url, params){
        return http.post(url, qs.stringify(params));
    },
    postObj: function(url, params) {
        return http.post(url, params, {headers: {'Content-Type': 'application/json'}});
    },
    fileUpload: function (url, params) {
        var formData = new FormData();
        if(params) {
            for(var key in params) {
                // if((arr instanceof Array)typeof params[key] === 'array' && params[key].length > 0) {
                if((params[key] instanceof Array) && params[key].length > 0) {
                    var value = params[key];
                    // alert(typeof(value));
                    for(var i = 0;i < value.length;i++) {
                        if(value[i]){
                            formData.append(key,value[i]);
                        }
                    }
                } else {
                    if(params[key]){
                        formData.append(key, params[key]);
                    }
                }
            }
        }
        return http.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}});
    },
    fileUpload2: function (url, params) {
        let formData = new FormData();
        Object.keys(params).forEach((key)=>{
            formData.append(key, params[key]);
        })
        return http.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}});
    },

    request: function (url, method, responseType, params) {
        var headers = {
            'Content-Type': 'application/xml;application/json; application/octet-stream'
        };
        return http.request({url: url, method: method, responseType: responseType, params: params, headers});
    },
    all: function (reqList) {
        return axios.all(reqList);
    },
    download: function(url, method, params) {
        let headers = {
            'Content-Type': 'application/xml;application/json; application/octet-stream'
        };
        http.request({url: url, method: method, responseType: 'blob', params: params, headers}).then((res)=>{
            if (res.status === 200) {
                if (!res.data) {
                    return false;
                } else {
                    const blob = res.data;
                    const contentDisposition = res.headers['content-disposition'];
                    let fileName = 'unknown';
                    if (contentDisposition) {
                        fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1]);
                    }
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click(); // 点击下载
                    window.setTimeout(function () {
                        URL.revokeObjectURL(blob);
                        document.body.removeChild(link);
                    }, 0);
                }
            }
        }).catch((reason) => {
            console.log(reason);
        });
    }
}
